import React from 'react';
import _ from 'underscore';
import {connect} from 'react-redux';
import { useParams } from 'react-router-dom';
import AuctionPage from '../components/AuctionPage/AuctionPage';
import {prepareAuction} from '../ducks';
import {scrollToTop} from '../utils/window';
import {
    getTransform,
    OBJECT_AUCTION
} from '../utils/sources';

const ConnectedAuctionPage = connect(
    (state, { auctionId }) => {
        let transform = getTransform(OBJECT_AUCTION);
        let auction = transform(state.auction.data);
        let mainPhoto, secondaryPhotos, overflowPhotos;

        if (auction && auction.photos && auction.photos.length) {
            mainPhoto = auction.photos[0];
            secondaryPhotos = auction.photos.slice(1, 7);
            overflowPhotos = _.rest(auction.photos, 7);
        }

        return {
            auction,
            mainPhoto,
            secondaryPhotos,
            overflowPhotos,
            // Pass auctionId as match-like object for component compatibility
            match: { params: { auctionId } }
        };
    },
    (dispatch, { auctionId }) => ({
        onInitialize: () => {
            dispatch(prepareAuction(auctionId));
            scrollToTop();
        }
    })
)(AuctionPage);

// Wrapper component that extracts params and passes them to connected component
function AuctionPageContainer(props) {
    const { auctionId } = useParams();
    return React.createElement(ConnectedAuctionPage, Object.assign({}, props, { auctionId: auctionId }));
}

export default AuctionPageContainer;
